import { createSelector } from 'reselect';

import { get as _get } from 'lodash';

import { selectFirestore, selectListPendingFactory, selectItemPendingFactory } from 'services/selectors';
import { utils as uploaderUtils } from 'modules/uploader';

const selectImagesState = state => state.images;

const selectPending = createSelector(selectImagesState, images => images.pending);

export const selectListPending = selectListPendingFactory(selectPending);
export const selectItemPending = selectItemPendingFactory(selectPending);

export const selectImages = createSelector(selectFirestore, firestore => {
    const images = _get(firestore, 'data.images') || {};
    const orderedImages = _get(firestore, 'ordered.images') || [];
    return Object.keys(images)
        .map(key => ({
            ...images[key],
            firestoreId: key,
        }))
        .filter(image => Boolean(orderedImages.find(({ id }) => id === image.id)));
});

export const selectUploaderImages = createSelector(selectImages, images =>
    images.map(image => ({
        ...uploaderUtils.imageToFile(image),
        firestoreId: image.firestoreId,
    })),
);
